var map = {
	"./Acropolis.png": "QfTL",
	"./Athens.png": "e5M+",
	"./Hero.png": "yTZy",
	"./Mask.png": "zoXT",
	"./Roles.png": "oS0m",
	"./Rome small.png": "HOoG",
	"./Rome.png": "34KX",
	"./Sparta.png": "h8ag"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "m5T6";